export { default } from './ApplicationBaseContent';
